export const checkPackType = (packList, packID) => {
    if (packID === 0) return ''
    let filtered = packList.filter(e => e.PackID === packID);
    let result = filtered[0]?.Pack_Type
    return result
}